class MaritalStatus {
    constructor(name) {
        this.name = name;
    }
}   

const maritalStatuses = [
    new MaritalStatus('Single'),
    new MaritalStatus('Married'),
    new MaritalStatus('Divorced'),
    new MaritalStatus('Widowed'),
    new MaritalStatus('Separated'),
];

export { MaritalStatus, maritalStatuses }